var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAreas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#E8FAEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.88 9L9 17.88V20.71L20.71 9H17.88ZM25.51 9.08L9.08 25.51C9.17 25.85 9.35 26.16 9.59 26.41C9.84 26.65 10.15 26.83 10.49 26.92L26.93 10.49C26.74 9.8 26.2 9.26 25.51 9.08ZM9 11C9 9.9 9.9 9 11 9H13L9 13V11ZM25 27C25.55 27 26.05 26.78 26.41 26.41C26.78 26.05 27 25.55 27 25V23L23 27H25ZM18.12 27H15.29L27 15.29V18.12L18.12 27Z",
    fill: "#26CD58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreas);
export default __webpack_public_path__ + "static/media/areas.1803354a5b2523f20988b77d009ef1fa.svg";
export { ForwardRef as ReactComponent };